import { useCallback } from 'react';

import { tournamentIdSchema, type Tournament } from '@/core/schemas';
import { env } from '@/config/env';
import { subscribeTournament } from '@/infrastructure/repositories/tournamentRepository';
import { useLiveData, type LiveData } from '@/shared/hooks/useLiveData';

/** The tournament this installation shows, configured per deployment. */
export const activeTournamentId = tournamentIdSchema.parse(env.tournamentId);

export function useTournament(): LiveData<Tournament> {
  const subscribe = useCallback(
    (onData: (value: Tournament) => void, onError: Parameters<typeof subscribeTournament>[2]) =>
      subscribeTournament(activeTournamentId, onData, onError),
    [],
  );

  return useLiveData<Tournament>(['tournament', activeTournamentId], subscribe);
}
